// Подключение стилей сброса стилей и нормализации
import 'modern-normalize/modern-normalize.css';

// Подключение основных стилей проекта
import 'aos/dist/aos.css';
import "@/styles/main.scss";

// Импорт функций из модулей
import detectTouchDevice from "@/core/detectTouchDevice.js";
import processLinks from "@/core/processLinks.js";
import applyIcons from "@/core/applyIcons.js";
import applyWidgets from "@/core/applyWidgets.js";
import calcScrollbarWidth from "@/core/calcScrollbarWidth.js";
import onDomReady from "@/utils/onDomReady.js";
import AOS from 'aos'

// Выполнение кода после полной загрузки DOM
onDomReady(function () {
    detectTouchDevice(); // Обнаружение устройств с сенсорными экранами
    calcScrollbarWidth(); // Расчет ширины полосы прокрутки
    processLinks(); // Обработка ссылок
    applyWidgets(); // Применение виджетов
    applyIcons(); // Применение иконок   
    AOS.init({
        offset: 20, // Смещение в пикселях (значение по умолчанию 120)
        delay: 10, // Задержка анимации (значение по умолчанию 0)
        duration: 400, // Длительность анимации (значение по умолчанию 400)
        easing: 'ease', // Тип анимации (значение по умолчанию 'ease')
        once: true, // Воспроизведение анимации только один раз (значение по умолчанию false)
        mirror: false, // Повтор анимации при прокрутке вверх (значение по умолчанию false)
    });
});


window.addEventListener('load', function() {
    AOS.refresh(); // Обновить AOS после загрузки страницы
});

window.addEventListener('resize', function() {
    AOS.refresh(); // Обновить AOS при изменении размера окна
});